// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase */
import moment from "moment"
import { omit } from "ramda"

import translate from "@kiwicom/frontend-app/scripts/tools/translate"
import type Journey from "@kiwicom/frontend-common/records/Journey"

import { DATE_FORMAT } from "../components/constants"
import type { Document, PassengerApi, PassengerEdit } from "./types"

const CASE_INSENSITIVE_KEYS = ["first_name", "last_name", "middle_name"]

export const countDifferenceBetweenValues = (a: string, b: string) => {
  const longer = a.length > b.length ? a : b
  const shorter = a.length <= b.length ? a : b

  return Array.from(longer).reduce((acc, next, i) => {
    if (i < shorter.length && next.toLowerCase() === shorter[i].toLowerCase()) {
      return acc
    }
    return acc + 1
  }, 0)
}

export const getChangedLetterCount = (newUserData: PassengerApi, oldUserData: PassengerApi) => {
  const firstNameChanges = countDifferenceBetweenValues(
    newUserData.first_name,
    oldUserData.first_name,
  )
  const middleNameChanges = countDifferenceBetweenValues(
    newUserData.middle_name,
    oldUserData.middle_name,
  )
  const lastNameChanges = countDifferenceBetweenValues(newUserData.last_name, oldUserData.last_name)

  return firstNameChanges + middleNameChanges + lastNameChanges
}

export const formatUser = (user: PassengerEdit): PassengerApi => ({
  birth_date: user.birth,
  document_expiry: user.document.expiration,
  document_number: user.document.code,
  first_name: user.firstname.trim(),
  middle_name: user.middlename ? user.middlename.trim() : "",
  last_name: user.lastname.trim(),
  nationality: user.nationality,
  title: user.title,
})

export const compareUsers = (newUserData: PassengerApi, oldUserData: PassengerApi) => {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const compared: Record<string, any> = {}

  CASE_INSENSITIVE_KEYS.forEach((i) => {
    // @ts-expect-error: Flow to TS migration.
    if (newUserData[i].toLowerCase() !== oldUserData[i].toLowerCase()) {
      // @ts-expect-error: Flow to TS migration.
      compared[i] = newUserData[i]
    }
  })

  Object.keys(omit(CASE_INSENSITIVE_KEYS, newUserData)).forEach((i) => {
    // @ts-expect-error: Flow to TS migration.
    if (newUserData[i] !== oldUserData[i]) {
      // @ts-expect-error: Flow to TS migration.
      compared[i] = newUserData[i]
    }
  })

  if (compared.document_expiry && compared.document_expiry === "no-expiration") {
    compared.document_expiry = null
  }

  return compared
}

type RangeType = "day" | "month" | "year"
export const rangeTranslation = (type: RangeType, lower: number, upper: number) => {
  let rangeTypeKey = ""
  switch (type) {
    case "day":
      // @ts-expect-error: Flow to TS migration.
      rangeTypeKey = __("booking.passenger.id_day.label")
      break
    case "month":
      // @ts-expect-error: Flow to TS migration.
      rangeTypeKey = __("booking.passenger.id_month.label")
      break
    case "year":
      // @ts-expect-error: Flow to TS migration.
      rangeTypeKey = __("booking.passenger.id_year.label")
      break
    default:
      break
  }
  return {
    // @ts-expect-error: Flow to TS migration.
    tKey: __("forms.must_be_in_range"),
    values: {
      what: translate(rangeTypeKey),
      lower,
      upper,
    },
  }
}

export const getCurrentYear = () => moment().utc().toDate().getUTCFullYear()

export const getLatestFlightDeparture = (journey: Journey) =>
  journey.getFlights().last().getIn(["arrival", "when", "local"])

export const hasInvalidCode = (originalDocument: Document, currentDocument: Document) =>
  originalDocument.code && (!currentDocument.code || currentDocument.code.length < 4)

export const hasExpirationDate = (expiryDate?: string | null) =>
  expiryDate && expiryDate !== "no-expiration"

export const formatDate = (date?: string | null) =>
  // @ts-expect-error: Flow to TS migration.
  moment(date, DATE_FORMAT).isValid() ? moment(date, DATE_FORMAT).format(DATE_FORMAT) : date

export const formatUserNameForValidation = (name?: string | null) =>
  name ? name.trim().toLowerCase() : name
